import { useMemo } from "react"
import { AEMOptions, AEMPageType } from "@AEM/models/AEMPage.model"
import { AEMSvgData } from "@components/AEMSvg"
import { useAEMContent } from "./useAEMContent"
import { createItemsArrayMapper } from "@AEM/AEMContentMapper"
import { AEMIcon } from "@AEM/models/AEMResponse.model"
export type IconDictionary = Record<string, AEMSvgData>

export const useAEMIcons = (options?: AEMOptions) => {
	const { data, isLoading, error } = useAEMContent(AEMPageType.ICONS, {
		mapper: createItemsArrayMapper(),
		...options
	})
	const iconsData = (data as AEMIcon[]) ?? []
	const iconsDictionary = useMemo(() => {
		const dictionary: IconDictionary = {}

		if (iconsData && iconsData.length > 0) {
			for (const icon of iconsData) {
				dictionary[icon.fileName] = {
					path: icon.dynamicMediaUrl,
					title: icon.fileName,
					iconSvg: icon.icon
				}
			}
		}

		return dictionary
	}, [iconsData])

	const getIcons = (fileNames: string | string[]) => {
		if (!fileNames) iconsDictionary

		const iconNames = Array.isArray(fileNames) ? fileNames : [fileNames]
		const filteredDictionary: IconDictionary = {}
		for (const name of iconNames) {
			if (iconsDictionary[name]) {
				filteredDictionary[name] = iconsDictionary[name]
			}
		}

		return filteredDictionary
	}

	return {
		icons: iconsDictionary,
		isLoading,
		error,
		getIcons
	}
}
